import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './lib/auth';
import './index.css';
import App from './App';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

// Render React FIRST so nothing can block the app from mounting. The native
// niceties below (self-hosted fonts, status-bar styling) are best-effort — a
// failure there must never leave the user on a blank screen.
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Native-only enhancements. In web builds __NATIVE__ is false so this block is
// tree-shaken away entirely — zero runtime cost for web users.
if (__NATIVE__) {
  void (async () => {
    try {
      // Self-host fonts (Ionicons is registered via the local <script> the
      // native-html-transform Vite plugin injects into index.html).
      await Promise.all([
        import('@fontsource/bricolage-grotesque/400.css'),
        import('@fontsource/bricolage-grotesque/600.css'),
        import('@fontsource/bricolage-grotesque/700.css'),
        import('@fontsource/bricolage-grotesque/800.css'),
        import('@fontsource/plus-jakarta-sans/400.css'),
        import('@fontsource/plus-jakarta-sans/500.css'),
        import('@fontsource/plus-jakarta-sans/600.css'),
      ]);
    } catch (err) {
      console.error('Font preload failed (continuing):', err);
    }

    try {
      // Make the WebView extend behind the status bar (pairs with WindowCompat
      // in MainActivity), and keep the icon colour in sync with the system theme.
      const { StatusBar, Style } = await import('@capacitor/status-bar');
      await StatusBar.setOverlaysWebView({ overlay: true });
      const dark = window.matchMedia('(prefers-color-scheme: dark)');
      const applyStatusBar = () => {
        void StatusBar.setStyle({ style: dark.matches ? Style.Light : Style.Dark });
      };
      applyStatusBar();
      dark.addEventListener('change', applyStatusBar);
    } catch (err) {
      console.error('Status bar setup failed (continuing):', err);
    }
  })();
}
